import {
  validateEmail,
  validatePhone,
  validateRequired
} from '../../../../helpers/formValidation'
import { ValidateBranchForm } from '../typings'

const validateBranchForm = ({
  values,
  errors,
  field
}: ValidateBranchForm): Record<string, string> => {
  let formErrors: Record<string, string> = { ...errors }
  const {
    coachingCenterId,
    branchName,
    address1,
    address2,
    country,
    state,
    city,
    zipCode,
    mobileNumber,
    email,
    isMainBranch,
    status,
    questionLimit,
    courseIds
  } = values || {}

  switch (field) {
    case 'instituteName':
      formErrors['instituteName'] = validateRequired(coachingCenterId)
      break
    case 'branchName':
      formErrors['branchName'] = validateRequired(branchName)
      break
    case 'address1':
      formErrors['address1'] = validateRequired(address1)
      break
    case 'address2':
      formErrors['address2'] = validateRequired(address2)
      break
    case 'country':
      formErrors['country'] = validateRequired(country)
      break
    case 'state':
      formErrors['state'] = validateRequired(state)
      break
    case 'city':
      formErrors['city'] = validateRequired(city)
      break
    case 'zipCode':
      formErrors['zipcode'] = validateRequired(zipCode)
      break
    case 'mobileNumber':
      formErrors['mobileNumber'] = validatePhone(mobileNumber)
      break
    case 'email':
      formErrors['email'] = validateEmail(email)
      break
    case 'mainBranch':
      formErrors['mainBranch'] = validateRequired(isMainBranch)
      break
    case 'status':
      formErrors['status'] = validateRequired(status)
      break
    case 'questionLimit':
      formErrors['questionLimit'] = validateRequired(questionLimit)
      break
    case 'availableCourses':
      formErrors['availableCourses'] = validateRequired(courseIds[0])
      break
    default:
      formErrors['instituteName'] = validateRequired(coachingCenterId)
      formErrors['branchName'] = validateRequired(branchName)
      formErrors['address1'] = validateRequired(address1)
      formErrors['address2'] = validateRequired(address2)
      formErrors['country'] = validateRequired(country)
      formErrors['state'] = validateRequired(state)
      formErrors['city'] = validateRequired(city)
      formErrors['zipCode'] = validateRequired(zipCode)
      formErrors['mobileNumber'] = validatePhone(mobileNumber)
      formErrors['email'] = validateEmail(email)
      formErrors['mainBranch'] = validateRequired(isMainBranch)
      formErrors['status'] = validateRequired(status)
      formErrors['questionLimit'] = validateRequired(questionLimit)
      formErrors['availableCourses'] =
        courseIds?.length > 0 ? validateRequired(courseIds[0]) : ''
  }

  return formErrors
}

export default validateBranchForm
